import {
    Dialog,
    DialogActions,
    Typography,
    Button,
    Box,
    IconButton,
    Paper
} from '@mui/material';
import { Close as CloseIcon, Celebration as CelebrationIcon } from '@mui/icons-material';
import logo from '../../assets/img/logo.png';

const DashboardPopup = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            maxWidth="sm"
            fullWidth
            onClose={onClose}
            PaperProps={{
                sx: {
                    position: 'relative',
                    background: '#f5f5f5'
                }
            }}
        >
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <img src={logo} alt="Total Turf Experience" style={{ width: '180px', marginBottom: '1.5rem' }} />
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* 2026 Fees Banner */}
                <Paper
                    elevation={0}
                    sx={{
                        p: 2,
                        mb: 3,
                        background: 'linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)',
                        borderRadius: 2,
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 0.5 }}>
                        <CelebrationIcon />
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            2026 Administrative Fees Now Open!
                        </Typography>
                        <CelebrationIcon />
                    </Box>
                </Paper>

                <Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
                    Before paying your waiver fees, please verify your children are added to your account.
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    Use the <b>Children</b> page in the sidebar to add or update your child list.
                </Typography>

                <DialogActions sx={{ justifyContent: 'center', pt: 3 }}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                    >
                        Got It
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default DashboardPopup; 